import React, { useEffect, useRef } from 'react';

import { usePaymentContext } from 'features/payment';

import { useCartContext } from 'state/cart';

import { ICashAppButton } from '../types';

import { CashAppStyledButton } from './cashapp-button.styled';
import { CashappError } from './cashapp-error';
import { useCashApp } from './use-cashapp.web';

export const CashAppButton: React.FC<ICashAppButton> = ({
  serverOrder,
  onResult,
  onError,
  showLoading,
}: ICashAppButton) => {
  const { isLoading, isDeclined, loadCashAppButton } = useCashApp({
    onResult,
    onError,
  });

  const { tipAmount } = useCartContext();
  const cartTotalCents = serverOrder?.cart?.totalCents || 0;
  const totalCents = cartTotalCents + (tipAmount || 0);

  const { lastCommitOrderErrorDate } = usePaymentContext();
  const previousLastCommitOrderErrorDate = useRef<number | null>(null);

  useEffect(() => {
    if (
      lastCommitOrderErrorDate &&
      lastCommitOrderErrorDate !== previousLastCommitOrderErrorDate.current
    ) {
      previousLastCommitOrderErrorDate.current = lastCommitOrderErrorDate;
      if (totalCents) {
        loadCashAppButton({ amount: totalCents / 100 });
      }
    }
  }, [lastCommitOrderErrorDate, loadCashAppButton, totalCents]);

  useEffect(() => {
    if (totalCents) {
      loadCashAppButton({ amount: totalCents / 100 });
    }
  }, [totalCents]);

  return (
    <>
      {isDeclined && <CashappError />}
      <CashAppStyledButton isLoading={showLoading || isLoading}></CashAppStyledButton>
    </>
  );
};
